import { render, staticRenderFns } from "./li-table.vue?vue&type=template&id=39a8787a&scoped=true"
import script from "./li-table.vue?vue&type=script&lang=js"
export * from "./li-table.vue?vue&type=script&lang=js"
import style0 from "./li-table.vue?vue&type=style&index=0&id=39a8787a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a8787a",
  null
  
)

export default component.exports